<ng-progress color="red" [thick]="true" [spinner]="false" [trickleSpeed]="500" [ease]="'easeInSine'" (started)="ngProgress.startedClass" (completed)="ngProgress.endedClass"></ng-progress>
<div class="subBlockContainer">
  <div class="subBlockContent">
    <div class="inner-subBlock-wrapper">
      <div class="page-title-wrapper">
        <div class="title blade-title-font">
          {{title}}
        </div>
        <i class="material-icons closebutton-pullfloat-right" [routerLink]="['/manageRenewalsNew']">close</i>
      </div>
      <div class="row filter-wrapper">
        <div class="col-md-3">
          <div class="searchInputGroup">
            <div class="searchIcon">
              <img src="../../images/new_ui/filter.png">
            </div>
            <input class="searchInput" type="text" placeholder="Filter" [(ngModel)]="searchField">
          </div>
        </div>
        <div class="col small-logo" id="right-filter-wrapper">
          <img src="https://portal.dickerdata.com.au/images/brands/autodesk.jpg" />
        </div>
      </div>
    </div>
    <loading-screen *ngIf="!loadContent" [showBlurTable]="true" (currentLoadingStatus)="onLoading($event)">
    </loading-screen>
    <div *ngIf="loadContent">
      <ng-container *ngIf="hasResult">
        <div class="noResult-wrapper">
          <div class="top-divider"></div>
          <div><img src="../images/new_ui/no-found.png"></div>
          <div>No results found</div>
          <div>Sorry, that filter combination has no results.<br>Please try different criteria.</div>
          <div style="margin-bottom: 20px;">
            <button (click)="tryAgain()" class="button button-red button-large">Try again</button>
          </div>
        </div>
      </ng-container>
      <div class="shared-outer-wrapper" style="margin-top:10px;" *ngIf="!hasResult">
        <table matSort (matSortChange)="sortData($event)" class="white">
          <thead>
            <tr class="row">
              <th mat-sort-header="name" class="col">End Customer</th>
              <th mat-sort-header="contrctNo" class="col">Contract No</th>
              <th mat-sort-header="oppNumber" class="col align-center">
                Opportunity Id
              </th>
              <th mat-sort-header="expiryDate" class="align-center col">
                Expiry Date
              </th>
              <th mat-sort-header="qty" class="align-center col-1">QTY</th>
              <th class="col align-center"></th>
            </tr>
          </thead>
          <tbody>

            <ng-container
              *ngFor="let message of sortedData | TableFilterMultiple:['name', 'opportunity_number', 'subscription_end_date', 'total_quantity'] : searchField">
              <tr class="row">
                <td class="col">{{message?.accounts.end_customer.account.name}}</td>
                <td class="col">{{message?.contract.contract_number}}</td>
                <td class="col">{{message?.opportunity_number}}</td>
                <td class="col ">{{message?.subscription_end_date}}</td>
                <td class="col-1 align-right" style="padding-right: 45px">{{message?.total_quantity}}</td>
                <td class="col button-wrapper">
                  <button class="button button-red button-mid button-hover-white"
                    (click)="manageRedirect(message?.opportunity_number)">Manage</button>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>

      </div>
    </div>
  </div>
  <div class="blockContainer narrow-sidebar" style="overflow:hidden !important;" id="levelTwo" [hidden]="!narrowMode">
    <div class="combination-loader">
      <div class="scroll-wrapper sidebar-loader">
        <div class="page-title-wrapper">
          <div class="title blade-title-font">
            {{title}}
          </div>
          <i class="material-icons closebutton-pullfloat-right" (click)="close()">close</i>
        </div>
        <div class="searchInputGroup">
          <div class="searchIcon search-carts">
            <img src="../images/new_ui/filter.png">
          </div>
          <input class="searchInput" type="text" placeholder="Filter" [(ngModel)]="searchField">
        </div>

        <ng-container *ngFor="let message of sortedData | TableFilter: 'opportunity_number' : searchField">
          <div class="menu-wrapper"
            [class.active]="isActive(message?.opportunity_number, message?.contract.contract_number)"
            (click)="manageRedirect(message?.opportunity_number)">
            <div class="total-div">
              <div class="narrow-title">{{message?.accounts.end_customer.account.name}}</div>
              <span class="narrow-text">{{message?.subscription_end_date}} |
                Qty: {{message?.total_quantity}} </span>
            </div>
          </div>
        </ng-container>
      </div>
      <div class="child-loader">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>